import { useQuery } from '@apollo/client';
import SVLoadingWrapper from '@apps/www/src/www/containers/SVLoadingWrapper';
import SVPageMeta from '@apps/www/src/www/containers/SVPageMeta';
import CompanyQuery from '@apps/www/src/www/queries/CompanyQuery';
import CompanyUsersQuery from '@apps/www/src/www/queries/CompanyUsersQuery';
import SVLoadingIndicator from '@pkgs/shared-client/components/SVLoadingIndicator';
import SVPageHeader from '@pkgs/shared-client/components/SVPageHeader';
import SVPageTitle from '@pkgs/shared-client/components/SVPageTitle';
import SVUsersList from '@pkgs/shared-client/components/SVUsersList';
import usePaginatedQuery from '@pkgs/shared-client/hooks/usePaginatedQuery';
import { useRouter } from 'next/router';

const _UsersList = ({ companySlug }: { companySlug: string }) => {
	const { items, loading, paginate, isLimited } = usePaginatedQuery(CompanyUsersQuery, {
		variables: {
			slug: companySlug,
		},
	});

	return (
		<SVUsersList
			users={items || null}
			isLoading={loading}
			onPaginate={paginate}
			isLimited={isLimited}
		/>
	);
};

const SVCompanyDetailPage = () => {
	const router = useRouter();
	const companySlug = String(router.query.companySlug);
	const { data, loading, error } = useQuery(CompanyQuery, {
		variables: {
			slug: companySlug,
		},
	});

	if (error) {
		throw error;
	}

	return (
		<SVLoadingWrapper size={SVLoadingIndicator.SIZES.PAGE} isLoading={loading}>
			{() => {
				if (!data) {
					return null;
				}

				const meta = {
					title: data.companyBySlug.name,
				};

				return (
					<>
						<SVPageMeta {...meta} />

						<SVPageHeader>
							<SVPageTitle>{data.companyBySlug.name}</SVPageTitle>
						</SVPageHeader>

						<_UsersList companySlug={companySlug} />
					</>
				);
			}}
		</SVLoadingWrapper>
	);
};

export default SVCompanyDetailPage;
